import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/material/styles";
//Limitless imports
import CustomerButton from "../../customer-button/CustomerButton";
const useStyles = makeStyles(theme => {
  var _theme$palette$footer, _theme$palette$footer2;
  return {
    buttonFooterContainer: {
      display: "flex",
      flex: "1",
      justifyContent: "center",
      alignItems: "center",
      borderTop: "2px solid rgba(0, 0, 0, 0.06)",
      backgroundColor: (_theme$palette$footer = (_theme$palette$footer2 = theme.palette.footer) === null || _theme$palette$footer2 === void 0 ? void 0 : _theme$palette$footer2.backgroundColor) !== null && _theme$palette$footer !== void 0 ? _theme$palette$footer : theme.palette.primary.main,
      borderBottomRightRadius: 12,
      borderBottomLeftRadius: 12
    }
  };
});
const ButtonFooter = ({
  onClick,
  title,
  id
}) => {
  var _theme$palette$footer3, _theme$palette$footer4, _theme$palette$footer5, _theme$palette$button, _theme$palette$button2;
  const classes = useStyles();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.buttonFooterContainer
  }, /*#__PURE__*/React.createElement(CustomerButton, {
    style: {
      height: 44,
      textAlign: "center",
      color: (_theme$palette$footer3 = (_theme$palette$footer4 = theme.palette.footer) === null || _theme$palette$footer4 === void 0 ? void 0 : _theme$palette$footer4.color) !== null && _theme$palette$footer3 !== void 0 ? _theme$palette$footer3 : theme.palette.primary.contrastText,
      backgroundColor: ((_theme$palette$footer5 = theme.palette.footer) === null || _theme$palette$footer5 === void 0 ? void 0 : _theme$palette$footer5.backgroundColor) || ((_theme$palette$button = theme.palette.buttons) === null || _theme$palette$button === void 0 ? void 0 : (_theme$palette$button2 = _theme$palette$button.submit) === null || _theme$palette$button2 === void 0 ? void 0 : _theme$palette$button2.backgroundColor) || theme.palette.primary.main
    },
    onClick: onClick,
    component: "div",
    id: id
  }, title));
};
export default ButtonFooter;
ButtonFooter.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};